export default __webpack_public_path__ + "static/media/TRX in contract - Icon.a93cd512.svg";